import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;

export default function getDeliveryTemplate(params) {
  return request.get(`${apiUrlV1}/delivery/template/`, { params }).then(res => res.data.results[0]);
}
